export default function GuiasBuscar() {
	return (
		<div className="mx-auto max-w-[1200px] space-y-6 pb-20">
			<section className="rounded-2xl border border-[rgba(var(--border),_0.35)] bg-[rgba(var(--panel),_0.6)] p-6">
				<h1 className="text-lg font-semibold">Búsqueda de guías</h1>
				<p className="mt-2 text-sm text-[rgba(var(--fg),_0.7)]">Interfaz de búsqueda de guías (placeholder).</p>
			</section>
		</div>
	);
}
